// eslint-disable-next-line no-shadow
export enum LogoutEnum {
	USER_LOGGED_OUT = 'USER_LOGGED_OUT',
	RESPONSE_INTERCEPTOR = 'RESPONSE_INTERCEPTOR',
	FIREBASE_GET_CURRENT_USER_CATCH = 'FIREBASE_GET_CURRENT_USER_CATCH',
	FIREBASE_TOKEN_CATCH = 'FIREBASE_TOKEN_CATCH',
	UNVERIFIED_TOKEN = 'UNVERIFIED_TOKEN',
	DELETED_USER = 'DELETED_USER',
}
